import React from 'react'
import styled from '@emotion/styled'
import Async from 'react-promise'
import Truncate from 'react-truncate'
import { spacer } from 'stylist'
import listify from 'listify'
import pick from 'lodash/pick'
import keys from 'lodash/keys'
import entries from 'lodash/entries'
import at from 'lodash/at'
import sortBy from 'lodash/sortBy'
import size from 'lodash/size'
import { commaify } from 'utils'
import { getQuals, getLocales } from 'utils/api'
import { Bold, Pewter, Slate } from 'components/Text'
import { ResponsiveContainer } from 'components/Container'
import { GrowCol } from 'components/Col'
import Tooltip from 'components/Tooltip'

const displayValue = (value, unit) =>
  value ? (
    <React.Fragment>
      {typeof value === 'number' ? commaify(value) : value}
      {unit}
    </React.Fragment>
  ) : (
    '---'
  )

const Value = Bold.withComponent(Slate)
const SectionCol = styled(GrowCol)`
  margin-bottom: ${spacer(3)};
`
class Section extends React.Component {
  state = {
    truncated: null
  }

  handleTruncate = truncated => {
    if (this.state.truncated !== truncated) {
      this.setState({ truncated })
    }
  }

  render() {
    const { title, value, unit = '', truncate = false } = this.props
    return (
      <SectionCol>
        <Pewter>{title}</Pewter>
        <Value>
          {truncate ? (
            <Tooltip
              id={`${title}-tooltip`}
              contents={displayValue(value, unit)}
              enabled={this.state.truncated}
            >
              <Truncate lines={1} onTruncate={this.handleTruncate}>
                {displayValue(value, unit)}
              </Truncate>
            </Tooltip>
          ) : (
            displayValue(value, unit)
          )}
        </Value>
      </SectionCol>
    )
  }
}

const formatAnswers = (qualID, answers) => {
  if (qualID === 'age') {
    return answers.map((range, index) => (
      <div key={index}>
        {range.low && range.high ? `${range.low}-${range.high}` : '---'}
      </div>
    ))
  }
  return listify(answers, {
    finalWord: '&'
  })
}

const indexesToAnswers = (choices, indexes) =>
  sortBy(at(choices, indexes), item => choices.indexOf(item))

const Title = styled(Bold.withComponent('h5'))`
  margin: ${spacer(3)} 0;
`
const QualificationsSummary = ({ questions, locale }) => (
  <React.Fragment>
    <ResponsiveContainer>
      <Title>Sample Target</Title>
    </ResponsiveContainer>
    <Async
      promise={getQuals(locale)}
      then={({ data }) =>
        entries(pick(data, keys(questions))).map(
          ([qualID, qualData], index) => (
            <ResponsiveContainer key={index}>
              <Section
                truncate={qualID !== 'age'}
                title={qualData.title}
                value={formatAnswers(
                  qualID,
                  qualData.options && qualData.options.length
                    ? indexesToAnswers(qualData.options, questions[qualID])
                    : questions[qualID]
                )}
              />
            </ResponsiveContainer>
          )
        )
      }
    />
  </React.Fragment>
)

const TopTitle = styled(Title)`
  margin-top: 0;
`

class SummaryBox extends React.Component {
  state = {
    localeText: {}
  }

  constructor(props) {
    super(props)
    getLocales().then(resp => this.setState({ localeText: resp.data }))
  }

  render() {
    const {
      completions,
      interviewLength,
      fieldLength,
      incidence,
      pii,
      questions,
      locale
    } = this.props
    const { localeText } = this.state
    return (
      <div>
        <ResponsiveContainer>
          <TopTitle>Survey Info</TopTitle>
        </ResponsiveContainer>
        <ResponsiveContainer>
          <Section title="Qualified Participants:" value={completions} />
          <Section title="Days in Field:" value={fieldLength} />
        </ResponsiveContainer>
        <ResponsiveContainer>
          <Section
            title="Length of Survey:"
            value={interviewLength}
            unit=" Min"
          />
          <Section title="Qualifying Rate:" value={incidence} unit="%" />
        </ResponsiveContainer>
        <ResponsiveContainer>
          <Section
            title="Country:"
            value={localeText[locale] ? localeText[locale].country : '---'}
          />
          <Section
            title="Language:"
            value={localeText[locale] ? localeText[locale].lang : '---'}
          />
        </ResponsiveContainer>
        <ResponsiveContainer>
          <Section
            title="Collects PII:"
            value={{ true: 'Yes', false: 'No' }[pii]}
          />
        </ResponsiveContainer>
        {size(questions) > 0 ? (
          <QualificationsSummary questions={questions} locale={locale} />
        ) : null}
      </div>
    )
  }
}

export default SummaryBox



// WEBPACK FOOTER //
// ./src/routes/estimate/SummaryBox.js